let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("PjV2H")).then(() => parcelRequire('9Hpkr'));